import React, { useState } from "react";
import PropTypes from "prop-types";
import "./MarkerDetails.css";
import axios from 'axios';

function MarkerDetails({ marker, onClose, onBackToPreview, onHashtagClick, showOnMap }) {
  const [translatedDescription, setTranslatedDescription] = useState("");
  console.log("selected marker hashtag: ", marker.hashtag);

  
  const translateDescription = async () => {
    try {
      const res = await axios.post('http://localhost:3001/translate', {
        text: marker.description,
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });
  
      if (res.data && res.data.translatedText) {
        setTranslatedDescription(res.data.translatedText);
      } else {
        console.error('Translation API returned an unexpected response:', res.data);
      }
    } catch (error) {
      console.error('Failed to translate text:', error.response || error);
    }
  };      
   

  const embedUrl = `https://www.youtube.com/embed/${marker.videoId}`;

  const [resizing, setResizing] = useState(false);
const [dimensions, setDimensions] = useState({ width: 400, height: '100vh' });
const [lastMousePos, setLastMousePos] = useState({ x: 0, y: 0 });

const handleMouseDown = (e, direction) => {
  setResizing(direction);
  setLastMousePos({ x: e.clientX, y: e.clientY });
  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', handleMouseUp);
};

const handleMouseMove = (e) => {
  if (!resizing) return;

  const dx = e.clientX - lastMousePos.x;
  const dy = e.clientY - lastMousePos.y;

  if (resizing === 'right') {
    setDimensions(prev => ({ ...prev, width: prev.width + dx }));
  }
  // Add similar conditions for other edges

  setLastMousePos({ x: e.clientX, y: e.clientY });
};

const handleMouseUp = () => {
  setResizing(false);
  document.removeEventListener('mousemove', handleMouseMove);
  document.removeEventListener('mouseup', handleMouseUp);
};


  return (
    <div className="marker-details" style={{ width: dimensions.width, height: dimensions.height }}>
      <div className="edge left-edge" onMouseDown={e => handleMouseDown(e, 'left')}></div>
      <div className="edge right-edge" onMouseDown={e => handleMouseDown(e, 'right')}></div>
      <div className="edge top-edge" onMouseDown={e => handleMouseDown(e, 'top')}></div>
      <div className="edge bottom-edge" onMouseDown={e => handleMouseDown(e, 'bottom')}></div>
      
      <button className="close-button" onClick={onClose}>×</button>
      <button className="back-button" onClick={onBackToPreview} hidden>Back</button>
      <button className="translate-button" onClick={translateDescription} hidden>Translate to English</button>
      <div className="marker-details-wrapper">
        <div className="marker-details-header">
          <h2>{marker.title}</h2>
        </div>
        <div className="marker-details-body">
          <p>{marker.description}</p>
          <p>{translatedDescription ? `Translated: ${translatedDescription}` : ''}</p>
          <p>Publication Date: {
            new Date(marker.pubDate).toLocaleDateString('en-GB', {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            })
          }</p>
        </div>

        <button className="showOnMap" onClick={showOnMap(marker)} hidden>Show on Map</button>

        <div className="ytvideo-container">
          <iframe
            className="ytvideo"
            title={marker.title}
            src={embedUrl}
            allow={
              "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            }
            allowFullScreen
          ></iframe>
        </div>
        <div className="hashtags">
            {marker.hashtag && Array.isArray(marker.hashtag) 
              ? marker.hashtag.map((tag, index) => (
                  <span key={index}>
                    <a 
                      href="#" 
                      onClick={(e) => { e.preventDefault(); onHashtagClick(tag); }}
                    >
                      #{tag}
                    </a>
                    {index !== marker.hashtag.length - 1 ? ', ' : ''}
                  </span>
                ))
              : ''}
        </div>

      </div>
    </div>
  );
}

MarkerDetails.propTypes = {
  marker: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
    hashtag: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  onClose: PropTypes.func.isRequired
};

export default MarkerDetails;
